































import { Page, Pageable, Usuario, UsuarioBase } from '@/models'
import type { Loja } from '@/models'
import { FindUsuarioUseCase } from '@/usecases'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import axios, { CancelTokenSource } from 'axios'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

@Component
export default class SeletorDeUsuario extends Vue {
	@Prop({ type: [Object, String], default: null }) value!: UsuarioBase | string | null
	@Prop({ type: String }) idUsuarioSalvo!: string | null
	@Prop({ type: Object }) loja!: Loja
	@Prop({type: Array, default: () => []}) excludes!: string[]
	@Prop({ type: Boolean, default: false }) somenteVendedor?: boolean
	@Prop({ type: Boolean, default: false }) somenteUsuariosAtivos?: boolean
	@Prop({ type: Boolean, default: false }) rotaSomenteVendedor?: boolean
	@Prop({ type: [String, Array] }) lojas?: string | string[] | null
	@Prop({ type: Array }) pdvs?: string[]
	@Prop({ type: Boolean, default: false }) somenteRepresentante?: boolean

	usuarios: Usuario[] = []	
	usuarioSalvo: UsuarioBase | null = null
	busca = ''
	pagina: Page<Usuario> | null = null
	cancelToken: CancelTokenSource | null = null
	findUsuarioUseCase = new FindUsuarioUseCase()
	carregando = true
	usuariosCarregados = 0
	carregouTodosOsUsuarios = false
	requisicaoAtual = 0

	pageable: Pageable = {
		page: 0,
		size: 5,
		sort: [],
	}

	async created() {
		if (this.idUsuarioSalvo) {
			this.carregando = false
			return
		}
		await this.buscar()
	}

	get usuarioDoValor(): UsuarioBase | null {
		const valor = this.value
		return valor && typeof valor === 'object' && valor.id && valor.nome
			? valor
			: null
	}

	get itens(): UsuarioBase[] {
		const selecionado = this.usuarioSalvo || this.usuarioDoValor
		if (!selecionado) return this.usuarios

		return [
			selecionado,
			...this.usuarios.filter(usuario => usuario.id !== selecionado.id),
		]
	}

	async buscar() {
		const requisicao = ++this.requisicaoAtual
		this.carregando = true
		if (this.cancelToken) this.cancelToken.cancel()
		try {
			this.cancelToken = axios.CancelToken.source()
			const params = {
				page: this.busca ? this.pageable.page || -1 : this.pageable.page || 0,
				size: this.pageable.size,
				nome: this.busca || undefined,
				somenteVendedor: this.somenteVendedor,
				somenteUsuariosAtivos: this.somenteUsuariosAtivos,
				lojas: this.lojas,
				pdvs: this.pdvs,
			}
			const config = { cancelToken: this.cancelToken.token }
			const pagina = this.rotaSomenteVendedor || this.somenteRepresentante
				? await this.findUsuarioUseCase.findAllVendedores({
					...params,
					somenteRepresentante: this.somenteRepresentante,
				}, config)
				: await this.findUsuarioUseCase.findAll(params, config)
			if (requisicao !== this.requisicaoAtual) return this.usuarios
			this.pagina = pagina
			this.pagina.content.forEach(usuario => {
				this.usuarios.push(usuario)
			})
			this.carregouTodosOsUsuarios = this.pagina.last || (this.pageable?.size ? this.pagina.content.length < this.pageable.size : true)
		} catch (error: any) {
			if (axios.isCancel(error) || requisicao !== this.requisicaoAtual) return
			this.pagina = null
			AlertModule.setError(error)
		} finally {
			if (requisicao === this.requisicaoAtual) this.carregando = false
		}

		return this.usuarios
	}

	async pageNext() {
		this.pageable.page = !this.pageable.page
			? 1
			: this.pageable.page += 1
		await this.buscar()
	}

	@Watch('idUsuarioSalvo', { immediate: true })
	async onChangeIdUsuarioSalvo(id: string | null) {
		if (!id) {
			this.usuarioSalvo = null
			return
		}
		if (this.usuarioSalvo && this.usuarioSalvo.id === id) return

		const jaCarregado = this.usuarios.find(usuario => usuario.id === id)
		if (jaCarregado) {
			this.usuarioSalvo = jaCarregado
			return
		}

		this.usuarioSalvo = this.usuarioDoValor

		try {
			const usuario = await this.findUsuarioUseCase.findById(id)
			if (this.idUsuarioSalvo !== id) return
			this.usuarioSalvo = usuario
		} catch (_) {
			if (this.idUsuarioSalvo !== id) return
			this.usuarioSalvo = this.usuarioDoValor
		}
	}

	@Watch('busca', { deep: true, immediate: true })
	onChangeBusca(busca: string, buscaAnterior: string) {
		this.pageable = {
			...this.pageable,
			page: 0,
		}
		if (!buscaAnterior || busca === buscaAnterior) {
			this.carregando = false
			return
		}
		this.usuarios = []
		this.usuariosCarregados = 0
		this.buscar()
	}

	get noDataMessage() {
		if (this.carregando) {
			return 'Carregando...'
		}
		if (!this.usuarios.length) {
			return 'Nenhum resultado encontrado...'
		}
		if (!this.busca) {
			return 'Digite para consultar...'
		}
		return '$vuetify.noDataText'
	}

	@Watch('lojas')
	onchangeLojaId() {
		this.pageable = {
			...this.pageable,
			page: 0,
		}
		this.usuarios = []
		this.usuariosCarregados = 0
		this.buscar()
	}
}

